import React from "react";
import OrderTitle from "./components/order_title";
import OrderForm from "./components/order_form";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OrderContext } from "./contexts/order_context";

const Order = (props) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <OrderContext.Provider value={{
      hotelId: props.hotel_id,
      termId: props.term_id,
      townId: props.town_id,
      productId: props.product_id,
      mealTypeId: props.meal_type_id,
      defaults: {
        adults: props.adults,
        children: props.children,
        rooms: props.rooms
      }
    }}>
      <QueryClientProvider client={queryClient}>
        <div className='container pt-$'>
          <OrderTitle />
          <OrderForm />
        </div>
      </QueryClientProvider>
    </OrderContext.Provider>
  )
}

export default Order;
